import { api } from '@/api'
import type { ApiPaginationResponse } from '@/api/typings/response.typing'
import type { Transaction } from '@/api/typings/transaction.typing'

export interface UserTransactionsFilters {
  page?: number
  [key: string]: unknown
}

export function getUserTransactionsAction(
  userId: string,
  filters: UserTransactionsFilters = {}
): Promise<ApiPaginationResponse<Transaction[]>> {
  const queryParams = new URLSearchParams()

  queryParams.append('filter[user]', userId)

  if (filters.page) {
    queryParams.append('page', String(filters.page))
  }

  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '' && key !== 'page') {
      queryParams.append(`filter[${key}]`, String(value))
    }
  })

  return api.get<ApiPaginationResponse<Transaction[]>>(`/transactions?${queryParams.toString()}`)
}
